import React from 'react';
import 'styles/aboutMe.scss';

const AboutMePage = () => {
    return (
        <div className='about-container'>
            <div className='flex-column'>
                <img
                    className='picture'
                    alt='Me!'
                    src={require('static/misc/me.png')}
                />
                <div className='socialMediaContainer'>
                    <a 
                        href='https://www.instagram.com/aprilbrust/' 
                        target='_blank'
                        rel='noopener noreferrer'
                        className='socialMedia'
                    >
                        <img
                            alt='Twitter'
                            title='Twitter'
                            src={require('static/socialMedia/instagram.png')}
                        />
                    </a>
                    <a 
                        href='mailto:aprilbrust@gmail.com' 
                        className='socialMedia'
                    >
                        <img
                            alt='Gmail'
                            title='Gmail'
                            src={require('static/socialMedia/gmail.svg')}
                        />
                    </a>
                </div>
            </div>
            <div className='text flex-column'>
                <div>
                    <b>April Brust</b> is a medical and scientific illustrator and animator with a
                    Master of Science in Biomedical Communications (MScBMC) from the University of Toronto.
                    She also holds a double major undergraduate degree in Cognitive Science and Public Health
                    Studies from Johns Hopkins University.
                </div>
                <p />
                <div>
                    Working in the field of medical and scientific
                    visual communication allows her to combine her rigorous science background with her passion
                    for art and design. Classical realism training at the Schuler School of Fine Arts has given
                    her solid footing informed by techniques of traditional masters, while her MScBMC is an
                    accreditation of skill in current digital 2D and 3D media.
                </div>
                <p />
                <div>
                    Her motivation is to put art
                    and visual design into the service of science, to disseminate information to audiences,
                    targeted or broad. Clients she has visualised for include physicians, research scientists,
                    educators, and medical legal professionals.
                </div>
                <p />
                <div>
                    Her work has been published in the journal of
                    Nature methods and has been recognized by the Association of Medical Illustrators with an
                    award of excellence.
                </div>
            </div>
        </div>
    )
};

export default AboutMePage;



// WEBPACK FOOTER //
// ./src/components/AboutMePage/AboutMePage.js